export default "__VITE_ASSET__BR41_d7c__"